import { mount } from "svelte";
import App from "./App.svelte";
import { polyfill } from "./polyfill";
import { initCognitoClient } from "./state/cognitoClient.svelte";
import { globalState } from "./state/globalState.svelte";

await polyfill();

if (import.meta.env.PROD) {
	const { setupSentry } = await import("./utils/setupSentry.js");
	setupSentry();
}

await initCognitoClient();

const root = document.querySelector("#root");
if (!root) {
	throw new Error("Could not find root element");
}

globalState.userAgent = window.navigator.userAgent;
mount(App, { target: root });
